export default "__VITE_ASSET__BdQabr8S__"